import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-desc_2",
  "use": "icon-desc_2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-desc_2\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10.65,15.38h2.7v2.7h-2.7Zm0-2h2.7V5.92h-2.7ZM24,12A12,12,0,1,1,12,0,12,12,0,0,1,24,12ZM12,2.7A9.3,9.3,0,1,0,21.3,12,9.31,9.31,0,0,0,12,2.7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol